'use client';

import React, { useMemo } from 'react';
import { Box, Divider } from '@castlery/fortress';
import { selectCoupons, selectOrder, getYotpoCustomerDetails } from '@castlery/modules-order-domain';
import { CouponDropdown } from '../coupon-dropdown/coupon-dropdown';
import { useAppSelector } from '@castlery/shared-redux-store';
import { CouponRowItem } from '../coupon-row-item/coupon-row-item';
import { selectedCurrentCustomer } from '@castlery/modules-user-domain';

interface CouponWalletProps {
  wrapperSx?: Object;
}
export function CouponWallet({ wrapperSx = {} }: CouponWalletProps) {
  const coupons = useAppSelector(selectCoupons) || [];
  const coupon = useAppSelector(selectOrder)?.coupon;
  const customer = useAppSelector(selectedCurrentCustomer) as { email: string; id: number } | null;

  const hasCoupons = coupons.length > 0;
  const [canEdit, setCanEdit] = React.useState<boolean>(false);
  const getPoints = useMemo(() => getYotpoCustomerDetails.select(customer?.email || ''), [customer]);
  const { data: yotpoCustomerDetails = {} } = useAppSelector(getPoints);
  const points = yotpoCustomerDetails?.points_balance || 0;

  const changeMode = () => {
    if (coupon) return;
    setCanEdit((pre) => !pre);
  };

  const closeDropDown = () => {
    setCanEdit(false);
  };

  return (
    <React.Fragment>
      <Box sx={{ p: 1, ...wrapperSx }}>
        {canEdit ? (
          <CouponDropdown coupons={coupons} editToggle={closeDropDown} />
        ) : (
          <CouponRowItem coupon={coupon} hasCoupons={hasCoupons || points > 0} editToggle={changeMode} />
        )}
      </Box>
      <Divider />
    </React.Fragment>
  );
}
export default CouponWallet;
